import React from 'react';
export function TransformationSection() {
  return <section className="py-20 px-5 bg-cream-dark text-center reveal" data-id="element-347">
      <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-text-dark mb-3.5 leading-[1.2]" data-id="element-348">
        Lo que cambia en 21 días
      </h2>
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-10 leading-relaxed italic" data-id="element-349">
        No es solo que lea mejor. Es lo que eso le hace sentir.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr] gap-5 max-w-[700px] mx-auto items-center" data-id="element-350">
        {/* Before */}
        <div className="bg-white rounded-xl py-7 px-5 shadow-[0_2px_16px_rgba(30,45,36,0.06)] border-t-[3px] border-t-[#C0392B]" data-id="element-351">
          <div className="text-[0.7rem] tracking-[0.12em] uppercase font-semibold mb-4 text-[#C0392B]" data-id="element-352">
            Hoy
          </div>
          <div className="flex items-start gap-2 mb-2.5 text-left text-[0.83rem] text-text-mid leading-[1.5]" data-id="element-353">
            <span className="shrink-0" data-id="element-354">😟</span> Llora o se niega antes de leer
          </div>
          <div className="flex items-start gap-2 mb-2.5 text-left text-[0.83rem] text-text-mid leading-[1.5]" data-id="element-355">
            <span className="shrink-0" data-id="element-356">😟</span> Se compara con sus compañeros
          </div>
          <div className="flex items-start gap-2 mb-2.5 text-left text-[0.83rem] text-text-mid leading-[1.5]" data-id="element-357">
            <span className="shrink-0" data-id="element-358">😟</span> Necesita ser empujado a
            practicar
          </div>
          <div className="flex items-start gap-2 mb-2.5 text-left text-[0.83rem] text-text-mid leading-[1.5]" data-id="element-359">
            <span className="shrink-0" data-id="element-360">😟</span> Vos improvisás y te sentís
            culpable
          </div>
        </div>

        {/* Arrow */}
        <div className="text-[2rem] text-terracotta sm:rotate-0 rotate-90" data-id="element-361">
          →
        </div>

        {/* After */}
        <div className="bg-white rounded-xl py-7 px-5 shadow-[0_2px_16px_rgba(30,45,36,0.06)] border-t-[3px] border-t-forest" data-id="element-362">
          <div className="text-[0.7rem] tracking-[0.12em] uppercase font-semibold mb-4 text-forest" data-id="element-363">
            Día 21
          </div>
          <div className="flex items-start gap-2 mb-2.5 text-left text-[0.83rem] text-text-mid leading-[1.5]" data-id="element-364">
            <span className="shrink-0" data-id="element-365">🌟</span> Pide más juegos de letras
          </div>
          <div className="flex items-start gap-2 mb-2.5 text-left text-[0.83rem] text-text-mid leading-[1.5]" data-id="element-366">
            <span className="shrink-0" data-id="element-367">🌟</span> Forma palabras con orgullo
          </div>
          <div className="flex items-start gap-2 mb-2.5 text-left text-[0.83rem] text-text-mid leading-[1.5]" data-id="element-368">
            <span className="shrink-0" data-id="element-369">🌟</span> Trae sus hojas de trabajo solo
          </div>
          <div className="flex items-start gap-2 mb-2.5 text-left text-[0.83rem] text-text-mid leading-[1.5]" data-id="element-370">
            <span className="shrink-0" data-id="element-371">🌟</span> Vos sabés exactamente qué hacer
          </div>
        </div>
      </div>
    </section>;
}